var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.766,
    r: 15,
    fill: "#ac1e1e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "robot_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 11,
    width: 14,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 11.766h13.5v7.875H8v-7.875z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#robot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.257 19.641a1.243 1.243 0 01-1.244-1.243v-5.389a1.243 1.243 0 112.487 0v5.389c0 .686-.556 1.243-1.243 1.243m-11.013 0A1.243 1.243 0 018 18.398v-5.389a1.243 1.243 0 112.487 0v5.389c0 .686-.556 1.243-1.243 1.243",
    fill: "#fff"
  }))));
}
export default SvgRobot;